export const BASE_WAGE = 40000;
export const AVERAGE_WAGE = 48967;

export function getFactor() {
  return Math.round((AVERAGE_WAGE / BASE_WAGE) * 1000) / 1000;
}

export function calculateIndex({ percentage, volume, price }) {
  if (!price) {
    return 0;
  }

  return ((volume * (percentage / 100)) / price) * getFactor();
}

export function roundToThree(value) {
  return Math.round(value * 1000) / 1000;
}

export function parseNumber(value) {
  return Number(value) || 0;
}
